/**
 * Loads the methodology's knowledge-base JSON (public/data/*.json) as typed
 * data. Vite (and Vitest, which shares Vite's pipeline) natively supports
 * JSON imports, so the same code path works in dev, in the production build,
 * and in tests — no runtime fetch, no server dependency (design D14).
 */

import methodologyJson from "../../public/data/methodology.json";
import archetypesJson from "../../public/data/archetypes.json";
import audioResourcesJson from "../../public/data/audio-resources.json";
import recommendationsJson from "../../public/data/recommendations.json";
import referencesJson from "../../public/data/references.json";
import manifestJson from "../../public/data/manifest.json";
import history2010Json from "../../public/data/history/2010/snapshot.json";
import history2018Json from "../../public/data/history/2018/snapshot.json";
import hybridizationsJson from "../../public/data/hybridizations.json";
import referenceLanguagesJson from "../../public/data/reference-languages.json";

import type {
  MethodologyFile,
  ArchetypesFile,
  AudioResourcesFile,
  RecommendationsFile,
  ReferencesFile,
  ManifestFile,
  History2010Snapshot,
  History2018Snapshot,
  HybridizationsFile,
  ReferenceLanguagesFile,
} from "./types";

export const methodology = methodologyJson as unknown as MethodologyFile;
export const archetypesData = archetypesJson as unknown as ArchetypesFile;
export const audioResources = audioResourcesJson as unknown as AudioResourcesFile;
export const recommendations = recommendationsJson as unknown as RecommendationsFile;
export const references = referencesJson as unknown as ReferencesFile;
export const manifest = manifestJson as unknown as ManifestFile;
export const history2010 = history2010Json as unknown as History2010Snapshot;
export const history2018 = history2018Json as unknown as History2018Snapshot;
export const hybridizations = hybridizationsJson as unknown as HybridizationsFile;
export const referenceLanguagesData = referenceLanguagesJson as unknown as ReferenceLanguagesFile;
export const referenceLanguages = referenceLanguagesData.referenceLanguages;

export const archetypes = archetypesData.archetypes;
